// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"11bd0c95","601":"9fa5bfb0","638":"c65026ec"}[chunkId] + ".chunk.js";
};